if (!customElements.get('card-product-upsell')) {
  customElements.define(
    'card-product-upsell',
    class CardProductUpsell extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-upsell-variant-select]');
        this.quickView = this.querySelector('quick-view');
        this.addIcon = this.quickView?.querySelector('[data-upsell-add-icon]');
        this.addLabel = this.quickView?.querySelector('[data-upsell-add-label]');
        this.priceRoot = this.querySelector('[data-upsell-price]');
        this.priceContainer = this.priceRoot?.querySelector('.price');
        this.image = this.querySelector('.card-upsell__image');
        this.defaultImageSrc = this.image?.getAttribute('src') || '';
        this.defaultImageSrcset = this.image?.getAttribute('srcset') || '';
        this.variants = this.getVariants();

        this.bindPriceFormatting();

        if (!this.select) return;
        this.select.addEventListener('change', () => this.onVariantChange());
      }

      disconnectedCallback() {
        this.priceObserver?.disconnect();
      }

      getVariants() {
        const script = this.querySelector('[data-upsell-variants]');
        if (!script) return [];
        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          console.error('Error parsing upsell variants JSON:', error);
          return [];
        }
      }

      onVariantChange() {
        const variant = this.variants.find((item) => String(item.id) === this.select.value);
        if (!variant) return;

        this.updateQuickView(variant);
        this.updatePrice(variant);
        this.updateImage(variant);
      }

      updateQuickView(variant) {
        if (!this.quickView) return;

        this.quickView.dataset.variantId = String(variant.id);
        this.quickView.setAttribute(
          'aria-label',
          variant.available ? this.quickView.dataset.addLabel : window.variantStrings.soldOut
        );
        this.addIcon?.classList.toggle('hidden', !variant.available);
        if (this.addLabel) {
          this.addLabel.textContent = variant.available
            ? this.quickView.dataset.addLabel
            : window.variantStrings.soldOut;
        }
      }

      updatePrice(variant) {
        if (!this.priceContainer) return;

        const isOnSale = variant.compare_at_price > variant.price;
        this.priceContainer.classList.toggle('price--on-sale', isOnSale);
        this.priceContainer.classList.toggle('price--sold-out', !variant.available);

        const regularItem = this.priceContainer.querySelector('.price__regular .price-item--regular');
        if (regularItem) regularItem.textContent = this.formatMoney(variant.price);

        const saleItem = this.priceContainer.querySelector('.price__sale .price-item--sale');
        if (saleItem) saleItem.textContent = this.formatMoney(variant.price);

        const compareItem = this.priceContainer.querySelector('.price__sale .price-item--regular');
        if (compareItem && variant.compare_at_price) {
          compareItem.textContent = this.formatMoney(variant.compare_at_price);
        }
      }

      formatMoney(cents) {
        const format = window.theme?.settings?.money_with_currency_format || '${{amount}}';
        return this.stripTrailingZeros(formatMoney(cents, format));
      }

      bindPriceFormatting() {
        if (!this.priceRoot) return;

        this.stripTrailingZerosInPrices();
        this.priceObserver = new MutationObserver(() => this.stripTrailingZerosInPrices());
        this.priceObserver.observe(this.priceRoot, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      stripTrailingZerosInPrices() {
        if (!this.priceRoot) return;

        const walker = document.createTreeWalker(this.priceRoot, NodeFilter.SHOW_TEXT);
        const nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);

        nodes.forEach((node) => {
          const next = this.stripTrailingZeros(node.nodeValue);
          if (next !== node.nodeValue) node.nodeValue = next;
        });
      }

      stripTrailingZeros(value) {
        return value.replace(/([.,٫]0+)(?=\D|$)/g, '');
      }

      updateImage(variant) {
        if (!this.image) return;

        if (variant.featured_image?.src) {
          const src = variant.featured_image.src.split('?')[0];
          this.image.src = `${src}?width=90`;
          this.image.alt = variant.featured_image.alt || this.image.alt;
          if (this.image.hasAttribute('srcset')) {
            this.image.srcset = `${src}?width=90 90w, ${src}?width=180 180w`;
          }
          return;
        }

        if (this.defaultImageSrc) {
          this.image.src = this.defaultImageSrc;
          if (this.defaultImageSrcset) this.image.srcset = this.defaultImageSrcset;
        }
      }
    }
  );
}
